import clsx from "clsx";
import { FC, ReactNode } from "react";

import { RenderedText } from "@tsmono/inspect-components/content";

import styles from "./gridCells.module.css";

interface MarkdownCellDivProps {
  semanticClass: string;
  text: string;
  trimRenderedText?: boolean;
  /** Truncate the markdown to N characters before rendering. */
  truncateAt?: number;
}

/** Wraps truncated markdown in a 3-line-clamped cell. Used by list-mode
 *  renderers for `input`, `target`, `answer`. */
export const MarkdownCellDiv: FC<MarkdownCellDivProps> = ({
  semanticClass,
  text,
  trimRenderedText,
  truncateAt = 250,
}) => {
  return (
    <div
      className={clsx(
        semanticClass,
        "three-line-clamp",
        styles.cell,
        styles.wrapAnywhere
      )}
    >
      <RenderedText
        markdown={text}
        truncateAt={truncateAt}
        className={
          trimRenderedText
            ? clsx("no-last-para-padding", styles.noLeft)
            : undefined
        }
        forceRender={true}
        renderer="fragment"
      />
    </div>
  );
};

/** Centered single-line cell for score values. */
export const ScoreCellDiv: FC<{ children?: ReactNode }> = ({ children }) => (
  <div className={clsx(styles.cell, styles.score)}>{children}</div>
);

/** Plain text cell with single-line ellipsis (grid-mode default for
 *  textual columns). */
export const PlainTextCellDiv: FC<{
  semanticClass?: string;
  children?: ReactNode;
}> = ({ semanticClass, children }) => (
  <div
    className={clsx(semanticClass, styles.cell)}
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </div>
);
